import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import useId from 'hooks/useId';
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import {connect} from 'react-redux'
import DoubleButton from '../components/DoubleButton';
import ConditionForm from './ConditionForm';

const style = theme => ({
    root: {}
})

function NewCondition(
    {
        classes,
        onAdd,
        onClose,
        formSubmit,
    	partId,
        initValues,
        elementList,
        selectedItems,
        showParts
    }) {
    const formId = useId();

    const handleClose = () => {
        onClose();
    }

    const handleSubmit = () => {
        formSubmit[formId]()
    }

    const handleAdd = (values) => {
        onAdd(values);
    }

    return (
        <Dialog
            title={initValues ? Tr('edit_condition') : Tr('new_condition')}
            open={true}
            maxWidth={'md'}
            onClose={handleClose}
            transitionDuration={0}
        >
            <ConditionForm
                initValues={initValues}
                editable={showParts}
                onSubmit={handleAdd}
                id={formId}
				partId={partId}
                elementList={elementList}
                selectedItems={selectedItems}
            />
            <div className={classes.actions}>
                {showParts && <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={initValues ? Tr('save') : Tr('add')}
                    onClickFirst={handleClose}
                    onClickSecond={handleSubmit}
                />}
            </div>
        </Dialog>
    )
}

NewCondition.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(withStyles(style)(NewCondition));